var map = {
	"./1st-place-medal.svg": "bd62",
	"./add-image-s.svg": "c142",
	"./administrative-tools.svg": "efa6",
	"./apple-watch.svg": "0d90",
	"./appstore.svg": "c65f",
	"./aquathlon-2.svg": "2fdb",
	"./aquathlon.svg": "953f",
	"./arrow-down.svg": "40aa",
	"./arrow-left.svg": "ae1a",
	"./arrow-right.svg": "db9d",
	"./arrow-up.svg": "b277",
	"./badge.svg": "856d",
	"./basketball-jersey.svg": "c3b1",
	"./basketball-player.svg": "cabe",
	"./basketball.svg": "2ab4",
	"./beach-volleyball.svg": "5efd",
	"./bell.svg": "066b",
	"./biathlon.svg": "6e11",
	"./bold.svg": "b4b2",
	"./bug.svg": "d81b",
	"./business.svg": "6fa3",
	"./calculator.svg": "f6a3",
	"./calendar.svg": "ef1b",
	"./camera.svg": "49fd",
	"./caret-right.svg": "deb2",
	"./chat-bubble.svg": "a312",
	"./chat.svg": "8136",
	"./check-bold.svg": "0381",
	"./check-circle-s.svg": "0319",
	"./check-circle.svg": "c57b",
	"./climbing.svg": "e584",
	"./clock.svg": "9e45",
	"./close-circle-s.svg": "d9be",
	"./close-circle.svg": "e926",
	"./close.svg": "8c41",
	"./clouds.svg": "db85",
	"./compare.svg": "c24f",
	"./compass.svg": "6217",
	"./connect.svg": "f2c2",
	"./copy.svg": "8430",
	"./counselor.svg": "16a2",
	"./cross-country-skiing.svg": "c7d1",
	"./crown.svg": "4e2d",
	"./cycling.svg": "8b4a",
	"./delete-s.svg": "e4aa",
	"./delete.svg": "f77b",
	"./deposit.svg": "b284",
	"./difficulty.svg": "d9c7",
	"./discount.svg": "07ac",
	"./dog-paw.svg": "9a3d",
	"./double-left.svg": "e132",
	"./double-right.svg": "ea99",
	"./down.svg": "1c27",
	"./download.svg": "4339",
	"./duathlon.svg": "872f",
	"./edit.svg": "5509",
	"./empty-flag.svg": "531f",
	"./environment.svg": "6c31",
	"./equestrian-tourism.svg": "c880",
	"./excel-export.svg": "0f2a",
	"./excel-import.svg": "3f84",
	"./exception.svg": "132f",
	"./exclamation-circle-s.svg": "d8cc",
	"./exclamation-circle.svg": "f1db",
	"./expand.svg": "5351",
	"./export.svg": "e40d",
	"./external-link.svg": "8ad4",
	"./eye-invisible.svg": "57c3",
	"./eye.svg": "df750",
	"./facebook.svg": "3483",
	"./feedback.svg": "6551",
	"./file-done.svg": "c079",
	"./filter.svg": "a46c",
	"./finish.svg": "fa1a",
	"./five-of-five.svg": "62c9",
	"./flag.svg": "2ed9",
	"./global.svg": "37b5",
	"./google.svg": "76f3",
	"./gun.svg": "bedd",
	"./gymnastics.svg": "76fd",
	"./haze.svg": "90e36",
	"./history.svg": "5a59",
	"./home.svg": "5a6a",
	"./hourglass.svg": "5b34",
	"./idea.svg": "46af",
	"./image.svg": "1297",
	"./info-circle-s.svg": "270f",
	"./info-circle.svg": "43f3",
	"./instagram.svg": "9077",
	"./italic.svg": "2bbd",
	"./leaderboard.svg": "b4a3",
	"./left.svg": "0b76",
	"./line-chart.svg": "4b37",
	"./linkedin.svg": "2de8",
	"./live.svg": "11d2",
	"./loading.svg": "1bec",
	"./lock.svg": "5e87",
	"./log-in.svg": "9682",
	"./logout.svg": "ea07",
	"./mail.svg": "358f",
	"./map.svg": "40ee",
	"./membership-card.svg": "5236",
	"./menu-fold.svg": "c8ab",
	"./menu-unfold.svg": "8e8e",
	"./menu.svg": "a891",
	"./minus-circle.svg": "c0be",
	"./minus.svg": "b993",
	"./money-collect.svg": "c8ec",
	"./more-horizontal.svg": "1bcb",
	"./more-vertical.svg": "3383",
	"./mountain.svg": "1080",
	"./my-location.svg": "32bc",
	"./navigation.svg": "0fef",
	"./notification.svg": "03d4",
	"./odnoklassniki.svg": "e9a2",
	"./ordered-list.svg": "3684",
	"./padlock.svg": "b940",
	"./partly-cloudy-day.svg": "153f",
	"./password.svg": "953f3",
	"./phone.svg": "7df6",
	"./pie-chart.svg": "71d2",
	"./play-circle.svg": "b9a9",
	"./play.svg": "35ce",
	"./plus-circle.svg": "a450",
	"./plus.svg": "529a",
	"./print.svg": "40f2",
	"./pulse.svg": "1799",
	"./query-arrow.svg": "c029",
	"./question.svg": "9fab",
	"./rain-cloud.svg": "75e2",
	"./rain.svg": "44b4",
	"./read.svg": "b477",
	"./redo.svg": "1386",
	"./right.svg": "f36b",
	"./rocket.svg": "75ed",
	"./rocking-horse.svg": "df43",
	"./rotate-left.svg": "537d",
	"./rotate-right.svg": "fab3",
	"./running.svg": "d05d",
	"./safety-float.svg": "3935",
	"./sand-clock.svg": "6e52",
	"./search.svg": "ed7f",
	"./select.svg": "6e39",
	"./selfie.svg": "09aa",
	"./settings.svg": "e104",
	"./shopping-bag.svg": "c83a",
	"./shopping-cart.svg": "c539",
	"./skiing.svg": "bfe7",
	"./snow.svg": "0a17",
	"./snowboarding.svg": "317b",
	"./soccer-player.svg": "92e3",
	"./soccer.svg": "ce0a",
	"./solution.svg": "8ae8",
	"./speedscating.svg": "0d53",
	"./star-filled.svg": "4c94",
	"./star.svg": "29a8",
	"./steps.svg": "4bdb",
	"./stopwatch.svg": "c95a",
	"./storm.svg": "5842",
	"./strikethrough.svg": "ae2e",
	"./summer.svg": "ec8a",
	"./sup.svg": "7d50",
	"./swimming.svg": "41b1",
	"./sync.svg": "943f",
	"./table-tennis.svg": "701d",
	"./table.svg": "3bd9",
	"./team.svg": "8674",
	"./telegram.svg": "70f2",
	"./tennis-player.svg": "b985",
	"./tennis.svg": "fb57",
	"./ticket.svg": "a1fd",
	"./tiktok.svg": "34a4",
	"./time-limit.svg": "722d",
	"./timer.svg": "e8ca",
	"./track-and-field.svg": "42c4",
	"./triathlon.svg": "7619",
	"./trophy.svg": "25d2",
	"./twitter.svg": "1c78",
	"./underline.svg": "c1ec",
	"./undo.svg": "b75d",
	"./unexpand.svg": "067c",
	"./unordered-list.svg": "8341",
	"./up.svg": "e465",
	"./upload.svg": "7e51",
	"./user-edit.svg": "cd59",
	"./user-groups.svg": "9f16",
	"./user.svg": "18f0",
	"./usergroup-add.svg": "7c2a",
	"./video.svg": "2ce4",
	"./view-agenda.svg": "97c1",
	"./view-compare.svg": "e269",
	"./vkontakte.svg": "8184",
	"./walking.svg": "bb43",
	"./warning-s.svg": "a806",
	"./warning.svg": "522e",
	"./whistle.svg": "1485",
	"./windsurfing.svg": "1167",
	"./withdrawal.svg": "a046",
	"./youtube.svg": "1e7f",
	"./zoom-in.svg": "ff79",
	"./zoom-out.svg": "8ef4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f1d";